// Abbreviated month names with trailing periods (May is left unabbreviated).
const MONTHS_ABBR = [
    'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.',
    'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.',
];

/**
 * Format a YYYY-MM-DD date string for display, e.g. "2026-11-04" -> "Nov. 4, 2026".
 * Parses the date parts directly (no Date object) so the result never shifts by a
 * day due to timezone offsets. Falls back to the raw input if it can't be parsed.
 */
export function formatDisplayDate(value: string | null | undefined): string {
    if (!value) return '';
    const ymd = String(value).slice(0, 10);
    const [y, m, d] = ymd.split('-').map(Number);
    if (!y || !m || !d || m < 1 || m > 12) return ymd;
    return `${MONTHS_ABBR[m - 1]} ${d}, ${y}`;
}

/**
 * Get today's date in America/New_York timezone as YYYY-MM-DD.
 * This ensures the map always defaults to today's date in US Eastern time,
 * regardless of the server's timezone or the user's browser timezone.
 */
export function getTodayEastern(): string {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const parts = formatter.formatToParts(now);
    const year = parts.find(p => p.type === 'year')?.value || '';
    const month = parts.find(p => p.type === 'month')?.value || '';
    const day = parts.find(p => p.type === 'day')?.value || '';
    return `${year}-${month}-${day}`;
}
